import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import DashboardSwitcher from "./DashboardSwitcher";
import DashboardSubSwitcher from "./DashboardSubSwitcher";

export default function MonitoringDashboardRoutes(props) {
    return (
        <Routes>
            <Route path="/" element={ <DashboardSwitcher /> }/>
            <Route path="/sub" element={ <DashboardSubSwitcher /> }/>
            <Route path="*" element={ <Error404/> }/>
        </Routes>
    );
}